import { type ComponentPropsWithRef } from 'react';
import s from './Input.module.css';
import { useInput } from './InputRoot.js';

interface TextareaCounterProps extends ComponentPropsWithRef<'div'> {}

const TextareaCounter = ({ ...attrs }: TextareaCounterProps) => {
  const { count, maxLength } = useInput();
  const isCounterEnabled = maxLength && maxLength > 0;

  if (!isCounterEnabled) return null;

  return (
    <div
      className={s.count}
      role="status"
      aria-live="polite"
      aria-label={
        isCounterEnabled
          ? `${count} of ${maxLength} characters used`
          : undefined
      }
      {...attrs}
    >
      {isCounterEnabled && `${count} / ${maxLength}`}
    </div>
  );
};

export { TextareaCounter };
